import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
export const OptionalFormattedMessage = ({
  message,
  options
}) => {
  if (message && isValidI18nKey(message)) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: message,
      options: options
    });
  }
  return null;
};